import React, { useState, useEffect, useCallback } from 'react';
import useIdleTimer from 'modules/auth/useIdleTimer';
import { logout } from 'modules/auth/actions';

const COUNTDOWN_SECONDS = 60;

function IdleTimerModal() {
  const [isVisible, setIsVisible] = useState(false);
  const [countdown, setCountdown] = useState(COUNTDOWN_SECONDS);

  const handleIdle = useCallback(() => {
    setCountdown(COUNTDOWN_SECONDS);
    setIsVisible(true);
  }, []);

  const handleContinue = useCallback(() => {
    setIsVisible(false);
    setCountdown(COUNTDOWN_SECONDS);
  }, []);

  const handleLogout = useCallback(() => {
    setIsVisible(false);
    logout();
  }, []);

  useIdleTimer(handleIdle);

  useEffect(() => {
    if (!isVisible) return undefined;
    if (countdown <= 0) {
      handleLogout();
      return undefined;
    }
    const timer = setTimeout(() => setCountdown((c) => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [isVisible, countdown, handleLogout]);

  if (!isVisible) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center"
      style={{ zIndex: 10000 }}
    >
      <div className="absolute inset-0 bg-neutral-900/55" />
      <div className="relative bg-white rounded-lg shadow-modal max-w-md w-full mx-4 overflow-hidden">
        <div className="p-6">
          <h2 className="text-base font-bold text-neutral-900 mb-1">
            Session Expiring Soon
          </h2>
          <p className="text-sm text-neutral-600">
            You&apos;ve been inactive for 5 minutes. Your session will
            automatically end in{' '}
            <span className="font-semibold text-danger-600">{countdown}</span>{' '}
            second{countdown !== 1 ? 's' : ''}.
          </p>
          <p className="text-sm text-neutral-500 mt-1">
            Do you want to continue?
          </p>
        </div>
        <footer className="px-6 py-3 flex items-center justify-end gap-2 bg-neutral-50 border-t border-neutral-200">
          <button
            type="button"
            onClick={handleLogout}
            className="inline-flex items-center px-4 py-2 text-sm font-medium text-neutral-700 bg-white border border-neutral-300 rounded-lg hover:bg-neutral-50 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-600"
          >
            Log out
          </button>
          <button
            type="button"
            onClick={handleContinue}
            className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-brand-600 rounded-lg hover:bg-brand-700 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-600"
          >
            Continue Session
          </button>
        </footer>
      </div>
    </div>
  );
}

export default IdleTimerModal;
